import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';
import Layout from './layouts/Layout';
import DataContext from 'y4/context/DataContext';
import y from 'y4/Utils';
import axios from 'axios';

const App = props => {
  let initGlobalData = { menu: [] };

  //After browser refresh to get global data from session
  const sgd = y.getSessionItem('0a986ff307664e028c7dd967f6594f68_g');
  if (sgd) {
    initGlobalData = JSON.parse(sgd);
    if (initGlobalData.authentication) {
      const token = initGlobalData.authentication.token;
      axios.defaults.headers.common['token'] = token;
    }
  }

  //For DataContext.Provider prepare a function to set data into context
  const [globalData, setGlobalData] = useState(initGlobalData);

  return (
    <Router basename={process.env.REACT_APP_PUBLIC_URL}>
      <DataContext.Provider
        value={{
          globalData,
          setGlobalData: gd => {
            y.setSessionItem(
              '0a986ff307664e028c7dd967f6594f68_g',
              JSON.stringify(gd)
            );
            setGlobalData(gd);
          }
        }}
      >
        <Layout {...props} />
      </DataContext.Provider>
    </Router>
  );
};

export default App;
